import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouteDataService {
  private readonly router = inject(Router);
  // providedIn root : l'ActivatedRoute injecté est bien la racine de l'arbre de routes
  private readonly rootRoute = inject(ActivatedRoute);

  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)),
    { initialValue: null }
  );

  // data de la route la plus profonde, recalculées à chaque fin de navigation
  readonly lastRouteData = computed<Data>(() => {
    // dépendance explicite : les snapshots du router ne sont pas réactifs
    this.navigationEnd();
    return this.readDeepestRouteData();
  });

  private readDeepestRouteData(): Data {
    let route = this.rootRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data;
  }
}
